import { MatchEventClientModel } from '@sport1/types/sportData'
import { SummaryEventRowProps } from '@sport1/news-styleguide/Types'
import getSummaryEventRow from '@/components/LivetickerSummary/utils/getSummaryEventRow'

const hydrateMatchEvents = (matchEvents: MatchEventClientModel[] = []): SummaryEventRowProps[] => {
    const prevPenaltyEventIds: string[] = []
    const summary: SummaryEventRowProps[] = []
    const reversedMatchEvents = [...matchEvents].reverse()
    reversedMatchEvents.forEach((matchEvent, index) => {
        const { id, eventType } = matchEvent
        let summaryEventRow = getSummaryEventRow(matchEvent)

        // aggregate penalty shot for home and away team
        if (eventType === 'PENALTY_SHOT' && id && !prevPenaltyEventIds.includes(id)) {
            const nextMatchEvent = reversedMatchEvents[index + 1]
            if (
                nextMatchEvent &&
                nextMatchEvent.id &&
                nextMatchEvent.eventType === 'PENALTY_SHOT' &&
                summaryEventRow
            ) {
                prevPenaltyEventIds.push(nextMatchEvent.id)
                summaryEventRow = Object.assign(summaryEventRow, getSummaryEventRow(nextMatchEvent))
            }
        }

        // push event to summary
        if (id && !prevPenaltyEventIds.includes(id) && summaryEventRow) {
            summary.push(summaryEventRow)
        }
    })
    return summary.reverse()
}

export default hydrateMatchEvents
